import { z } from 'zod';
import AppleWebPushConfig from './static/apple-pushpackage/website.json';

export default {
	lang: 'ro',

	// main domain name, used for redirects, content urls etc.
	domain: 'adevarulfinanciar.ro',

	// internal cname alias (CloudFront origin host); only read by the shared video island in admin mode
	alternateDomain: 'adevarulfinanciar-ro.adh.reperio.news',

	friendlyName: 'Adevărul Financiar',
	friendlyURL: 'https://adevarulfinanciar.ro',
	// WebSite JSON-LD description (www/src/lib/StructuredCommon.ts)
	friendlyDescription: 'Publicație de business și finanțe pentru piața din România: piețe, companii, bănci, energie, imobiliare, macroeconomie și analize.',
	logoURL: 'https://adevarulfinanciar.ro/favicon-144-precomposed.png',

	// listing pages: 3 featured cards + 17 feed rows
	paginationLimitPerPage: 20,

	// global blocks fetched for every page (ad/analytics hooks — html pasted from admin, nothing in code)
	autoLoadGlobalBlocks: ['AdPosition_head', 'AdPosition_body_end'],

	// per-domain author field (admin author form; stored under author.custom_fields[domain]);
	// name, avatar and bio are native author fields. Read by AuthorBox, Opinion card, AuthorView.
	customAuthorFields: z.object({
		profession: z.string().optional().describe('Job title shown under the name (e.g. Redactor-șef adjunct, Editorialist)'),
	}),

	// legacy Safari website push (www/src/routes/apple_webpush, core.components/PushSubscription.svelte);
	// the signed package next to it is built with www/createPushPackage.mjs
	appleWebPushConfig: AppleWebPushConfig,

	// regex redirects matched against https://<host><pathname> (www/src/hooks.server.ts)
	redirects: {
		'\\/\\/www\\.adevarulfinanciar\\.ro\\/(.*)': {
			url: 'https://adevarulfinanciar.ro/$1',
			status: 301,
		},
		'\\/\\/adevarulfinanciar-ro\\.adh\\.reperio\\.news\\/(.*)': {
			url: 'https://adevarulfinanciar.ro/$1',
			status: 301,
		},
	},
};

// tags hidden from the article tag list / admin tag assistant stop-list
export const SYSTEM_TAGS = ['noads', 'nocomments', 'analiza', 'interviu', 'opinie', 'exclusiv', 'live', 'video', 'foto', 'galerie'];
